export default [
	{
		path: '/calon-agen',
		name: 'calon-agen',
		component: () => import('@/views/calon-agen/Index.vue'),
	},
]
